import { render } from "./CookiesControl.vue?vue&type=template&id=2ba1554d"
import script from "./CookiesControl.vue?vue&type=script&lang=js"
export * from "./CookiesControl.vue?vue&type=script&lang=js"

import "./CookiesControl.vue?vue&type=style&index=0&id=2ba1554d&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__